import { CSSProperties } from 'react'

import {
  BorderWidth,
  Colors,
  Spacings,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const ItemStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  flexGrow: 1,

  margin: toPx(Spacings.NODE_HORIZONTAL_PADDING),
  marginTop: toPx(Spacings.MEDIUM_HORIZONTAL),
  marginBottom: toPx(0),
  paddingBottom: toPx(Spacings.MEDIUM),
  borderBottom: `${BorderWidth.SMALL} solid ${Colors.Tints.NEUTRAL[5]}`,
}
